import { ButtonRounded } from 'is24-corecss';
import { IconS24CalendarClock24 } from '@is24/cosma-ui-icons';
import { Modal as Modals } from '@/components/common/display/modal/v3';
import type { BenefitModalProps } from '@/@types/benefitModalProps';
import { useIntl } from '@/i18n';
import styles from './AdacActivationPendingModal.module.css';

const { V3: Modal } = Modals;

export const AdacActivationPendingModal = ({ onClose }: Pick<BenefitModalProps, 'onClose'>) => {
  const { t } = useIntl();

  return (
    <Modal isVisible onClose={onClose} width={480} viewportHeight={false}>
      <Modal.Header className='padding-bottom-xs'>
        <Modal.CloseButton aria-label={t({ id: 'common.buttons.close' })} />
      </Modal.Header>
      <Modal.Content>
        <div className='align-center padding-horizontal-xl'>
          <div
            className={`${styles.icon} horizontal-center display-flex grid-align-center grid-justify-center margin-bottom-m`}
            aria-hidden='true'
          >
            <IconS24CalendarClock24 />
          </div>
          <Modal.Title className='font-heading-xsmall-bold margin-bottom-m'>
            {t({ id: 'benefits.adac.pending.title' })}
          </Modal.Title>
          <Modal.Description className='font-body-small-regular margin-bottom-l'>
            {t({ id: 'benefits.adac.pending.description' })}
            <br />
            {t({ id: 'benefits.adac.pending.emailNotice' })}
          </Modal.Description>
        </div>
      </Modal.Content>
      <Modal.Footer className={styles.footer}>
        <ButtonRounded variant='filledBrand' onClick={onClose} width='fixed'>
          {t({ id: 'common.buttons.close' })}
        </ButtonRounded>
      </Modal.Footer>
    </Modal>
  );
};
